import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from 'src/typography';
import { centsToDollars } from 'src/payments/utils';
import { SkeletonLoader } from 'shared/components';

export type TotalProps = {
  accented?: boolean;
  amount: number;
  discount?: boolean;
  icon?: JSX.Element;
  label: string;
  loading?: boolean;
};

export const TotalItem = ({ accented, amount, discount, icon, label, loading = false }: TotalProps): JSX.Element => (
  <TotalContainer>
    <NameContainer>
      {accented ? <Text weight='bold'>{label.toUpperCase()}:</Text> : <Text>{label}:</Text>}
      {icon}
    </NameContainer>
    {loading ? (
      <SkeletonLoader height={30} width={100} />
    ) : (
      <Text weight='bold'>
        {' '}
        {discount && <>-</>} {centsToDollars(amount)}
      </Text>
    )}
  </TotalContainer>
);

const TotalContainer = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[30]};
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;

const Text = styled(Typography.Body).attrs({
  size: 'small',
})`
  line-height: 18px;
`;

const NameContainer = styled(Text)`
  display: flex;
  align-items: center;
`;
